import {tns} from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', function () {

    const sliders = document.querySelectorAll('.editorial-carousel__list');
    for(const slider of sliders) {
        tns({

            container: slider,
            slideBy: 'page',
            autoplay: false,
            controls: true,
            nav: false,
            speed: 250,
            mouseDrag: true,
            gutter: 16,
            controlsText: ['', ''],
            items: 1,
            loop: false,
            onInit: function (instance) {
                instance.nextButton.ariaLabel = "Framåt";
                instance.prevButton.ariaLabel = "Bakåt";
            },
            controlsContainer: slider.closest(".editorial-carousel").querySelector('.editorial-carousel__controls'),
            responsive: {
                768: {
                    items: 2,
                    gutter: 24,
                },
                992: {
                    items: 3,
                    gutter: 24,
                }
            }

        });
    }
})
